import { render, staticRenderFns } from "./mahjongXmas.vue?vue&type=template&id=6f1936da&scoped=true"
import script from "./mahjongXmas.vue?vue&type=script&lang=js"
export * from "./mahjongXmas.vue?vue&type=script&lang=js"
import style0 from "./mahjongXmas.vue?vue&type=style&index=0&id=6f1936da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1936da",
  null
  
)

export default component.exports